import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Fatura } from '../../model/fatura';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { FaturamentoService } from '../../shared/faturamento.service';
import { OverlaySpinnerService } from '../../shared/overlay-spinner.sevice';

@Component({
  selector: 'mti-gerar-faturas',
  templateUrl: './gerar-faturas.component.html',
  styleUrls: ['./gerar-faturas.component.css']
})
export class GerarFaturasComponent {
  gerarForm = this.fb.group({
    competencia: [null, [Validators.required, Validators.pattern(/^\d{4}\-\d{2}$/)]],
    periodo: this.fb.group({
      inicio: [null, Validators.required],
      fim: [null, Validators.required]
    })
  });

  gerandoFaturas = false;

  faturas: Fatura[] = [];

  constructor(private faturamentoService: FaturamentoService, private fb: FormBuilder, private dialog: MatDialog, private overlaySpinnerService: OverlaySpinnerService, private snackBar: MatSnackBar) {}

  abreModalConfirmacaoGerarRecorrentes(): void {
    const competencia = this.gerarForm.get('competencia')?.value;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { titulo: `Gerar faturas recorrentes - ${competencia}`, pergunta: "Confirma a geração de faturas recorrentes?" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        this.gerandoFaturas = true;
        this.gerarFaturasRecorrentes();
      }
    });
  }

  abreModalConfirmacaoGerarMarcos(): void {
    const competencia = this.gerarForm.get('competencia')?.value;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { titulo: `Gerar faturas de Marcos - ${competencia}`, pergunta: "Confirma a geração de faturas de marcos?" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        this.gerandoFaturas = true;
        this.gerarFaturasMarcos();
      }
    });
  }

  gerarFaturasMarcos() {
    this.overlaySpinnerService.showSpinner();

    const competencia = this.gerarForm.get('competencia')?.value;

    const inicio = this.gerarForm.get('periodo.inicio')?.value;

    const fim = this.gerarForm.get('periodo.fim')?.value;

    this.faturamentoService.gerarFaturasMarcos(competencia, inicio, fim)
      .subscribe(result => {

        if (result.result === 'ok') {

          const snackRef = this.snackBar.open('Faturas geradas. Buscando as faturas...', 'ok', {
            duration: 6 * 1000,
          });

          snackRef.onAction().subscribe(() => {
            snackRef.dismiss();
          });

          this.buscarFaturas();

        } else {
          this.gerandoFaturas = false;
          this.overlaySpinnerService.stopSpinner();

          if (result.result == "error") {
            const snackRef = this.snackBar.open('houve um erro ao gerar as faturas:' + `${result.mensagem}`, 'ok', {
              duration: 6 * 1000,
            });

            snackRef.onAction().subscribe(() => {
              snackRef.dismiss();
            });

          }
        }


      },
        error => {
          this.gerandoFaturas = false;
          this.overlaySpinnerService.stopSpinner();
          const snackRef = this.snackBar.open('erro ao gerar as faturas recorrentes:' + error, 'fechar', {
            duration: 12 * 1000,
          });

          snackRef.onAction().subscribe(() => {
            snackRef.dismiss();
          });
        });
  }

  gerarFaturasRecorrentes() {
    this.overlaySpinnerService.showSpinner();

    const competencia = this.gerarForm.get('competencia')?.value;

    const inicio = this.gerarForm.get('periodo.inicio')?.value;

    const fim = this.gerarForm.get('periodo.fim')?.value;

    this.faturamentoService.gerarFaturasRecorrentes(competencia, inicio, fim)
      .subscribe(result => {

        if (result.result === 'ok') {

          const snackRef = this.snackBar.open('Faturas geradas. Buscando as faturas...', 'ok', {
            duration: 6 * 1000,
          });

          snackRef.onAction().subscribe(() => {
            snackRef.dismiss();
          });

          this.buscarFaturas();

        } else {
          this.gerandoFaturas = false;
          this.overlaySpinnerService.stopSpinner();

          if (result.result == "error") {
            const snackRef = this.snackBar.open('houve um erro ao gerar as faturas:' + `${result.mensagem}`, 'ok', {
              duration: 6 * 1000,
            });

            snackRef.onAction().subscribe(() => {
              snackRef.dismiss();
            });

          }
        }
       
        
      },
        error => {
          this.gerandoFaturas = false;
          this.overlaySpinnerService.stopSpinner();
          const snackRef = this.snackBar.open('erro ao gerar as faturas recorrentes:' + error, 'fechar', {
            duration: 12 * 1000,
          });

          snackRef.onAction().subscribe(() => {
            snackRef.dismiss();
          });
        });
  }

  buscarFaturas() {
    const competencia = this.gerarForm.get('competencia')?.value;

    this.faturamentoService.buscaFaturas(competencia, null, null)
      .subscribe(results => {
        this.faturas = results;
        this.gerandoFaturas = false;
        this.overlaySpinnerService.stopSpinner();
      },
        error => {
          this.gerandoFaturas = false;
          this.overlaySpinnerService.stopSpinner();
          const snackRef = this.snackBar.open('erro ao buscar as faturas recorrentes geradas:' + error, 'fechar', {
            duration: 12 * 1000,
          });

          snackRef.onAction().subscribe(() => {
            snackRef.dismiss();
          });
        });
  }

}
